import './addload.css'
import React from 'react'

function AddLoad() {
    return (
        <>
            <h3 className='dashboard-head-title'>Add Load</h3>
            <form>
                <div className=' load-form'>
                    <div className=' load-input-wrapper'>
                        <div className=' load-input'>
                            <label>Broker</label>
                            <input required type={'text'} placeholder="Mark Johnson" className='form-input_ input' />
                        </div>
                        <div className=' load-input'>
                            <label  >Pickup </label>
                            <select required name="" className='form-input_ select1'>
                                <option value="">Select</option>
                                <option selected value="title1">Chicago</option>
                            </select>
                        </div>
                        <div className=' load-input'>
                            <label>{`.`}</label>
                            <select required name="" className='form-input_ select1'>
                                <option value="">Select</option>
                                <option selected value="title1">IL</option>
                            </select>
                        </div>
                        <div className=' load-input'>
                            <label  >Destination </label>
                            <select required name="" className='form-input_ select1'>
                                <option value="">Select</option>
                                <option selected value="title1">Minneapolis</option>
                            </select>
                        </div>
                        <div className=' load-input'>
                            <label>{`.`}</label>
                            <select required name="" className='form-input_ select1'>
                                <option value="">Select</option>
                                <option selected value="title1">MN</option>
                            </select>
                        </div>
                        <div className=' load-input'>
                            <label>Pickup Date</label>
                            <input required type={'date'} className='form-input_ select1' />
                        </div>
                        <div className=' load-input'>
                            <label>Delivery Date</label>
                            <input required type={'date'} className='form-input_ select1' />
                        </div>
                        <div className=' load-input'>
                            <label>Rate</label>
                            <input required type={'text'} placeholder="3000" className='form-input_' />
                        </div>
                        <div className=' load-input'>
                            <label  >Delivery Status</label>
                            <select required name="" className='form-input_ select2'>
                                <option value="">Select</option>
                                <option value="" selected>Picked</option>
                            </select>
                        </div>
                        <div className=' load-input'>
                            <label  >Payment Status</label>
                            <select required name="" className='form-input_ select2'>
                                <option value="">Select</option>
                                <option value="" selected>Pending</option>
                            </select>
                        </div>
                    </div>
                    <div className='form-buttons'>
                        <button className='button-primary'>Add Load</button>
                        <button className='button-primary btn-cancel'>Cancel</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddLoad